exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h3[data-v-ed2721d2]{border:0 solid #ff0;min-height:173px}.txt[data-v-ed2721d2]{min-height:260px}.square45[data-v-ed2721d2]{text-align:center;position:absolute;z-index:1;margin:23px;background:#c20444;display:block;height:50px;width:50px;transform:rotate(45deg)}a[data-v-ed2721d2]:hover{background-color:#0e3d85;color:#fff}", ""]);

// exports
